import { Plugin } from '@ckeditor/ckeditor5-core';
import { FileDialogButtonView } from '@ckeditor/ckeditor5-upload';
import videoUploadIcon from '../theme/icons/video.svg';
import { createVideoTypeRegExp } from "./utils";
export default class VideoUploadUI extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoUploadUI';
    }
    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        const t = editor.t;
        const componentCreator = (locale) => {
            var _a;
            const view = new FileDialogButtonView(locale);
            const command = editor.commands.get('uploadVideo');
            const videoTypes = editor.config.get('video.upload.types');
            const videoMediaTypesRegExp = createVideoTypeRegExp(videoTypes);
            view.set({
                acceptedType: (_a = videoTypes === null || videoTypes === void 0 ? void 0 : videoTypes.map(type => `video/${type}`)) === null || _a === void 0 ? void 0 : _a.join(','),
                allowMultipleFiles: editor.config.get('video.upload.allowMultipleFiles')
            });
            view.buttonView.set({
                label: t('Upload Video'),
                icon: videoUploadIcon,
                tooltip: true
            });
            view.buttonView.bind('isEnabled').to(command);
            view.on('done', (evt, files) => {
                const videosToUpload = Array.from(files).filter(file => videoMediaTypesRegExp.test(file.type));
                if (videosToUpload.length) {
                    editor.execute('uploadVideo', { files: videosToUpload });
                }
            });
            return view;
        };
        editor.ui.componentFactory.add('uploadVideo', componentCreator);
        editor.ui.componentFactory.add('videoUpload', componentCreator);
    }
}
//# sourceMappingURL=videouploadui.js.map